import PropTypes from 'prop-types';
import cssVars from 'src/common/styles/variables';

/* eslint-disable max-len */
const ShareIcon = ({
  width,
  height,
  viewBox,
  onClick,
  className,
  dataTestId,
}) => (
  <svg
    width={width}
    height={height}
    viewBox={viewBox || '0 0 16 17'}
    fill={cssVars['--secondary-color-5']}
    className={className}
    data-testid={dataTestId}
    onClick={onClick}
  >
    <g>
      <path d="M15.5 9H14a.5.5 0 0 0-.5.5v5h-11v-5A.5.5 0 0 0 2 9H.5a.5.5 0 0 0-.5.5v7a.5.5 0 0 0 .5.5h15a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5z" />
      <path
        d="M4.06 6.31a.6.6 0 0 0 .87 0l1.83-1.82V11a.62.62 0 0 0 .62.62h1.24a.62.62 0 0 0 .62-.62V4.49l1.83 1.82a.6.6 0 0 0 .87 0l.88-.87a.63.63 0 0 0 0-.88l-3.51-3.5-.87-.88a.63.63 0 0 0-.88 0l-.87.88-3.51 3.5a.63.63 0 0 0 0 .88z"
        fillRule="evenodd"
      />
    </g>
  </svg>
);

ShareIcon.propTypes = {
  width: PropTypes.string,
  height: PropTypes.string,
  viewBox: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func,
};

export default ShareIcon;
